import React from 'react';
import { StickableTanstackTable } from 'components/common/Table/StickableTanstackTable';
import i18n from 'i18n';
import styles from './storedValueList.module.scss';
import { SearchBar } from 'components/common/SearchBar';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import {
  StoredValueListColumns,
  useStoredValueListModel
} from './StoredValueListModel';

export type StoredValueListProps = Record<string, never>;

export const StoredValueList: React.FC<StoredValueListProps> = () => {
  const { state, columns, loading, onHandleSearch } = useStoredValueListModel();

  return (
    <div className={styles.storedValueList}>
      {loading && <LoadingIndicator />}
      <div className={styles.titleArea}>
        <div className={styles.title}>
          {i18n.t('storedValueList.labels.title')}
        </div>
      </div>
      <div className={styles.filterArea}>
        <SearchBar
          model={{
            placeholder: i18n.t('storedValueList.placeholders.searchbar'),
            search: onHandleSearch,
            defaultValue: state.searchString
          }}
        />
      </div>
      <div className={styles.contentArea}>
        <StickableTanstackTable
          stickFirstColumn
          stickLastColumn
          keyField={StoredValueListColumns.ID}
          data={state.filteredList}
          columns={columns}
          noDataIndication={i18n.t('storedValueList.labels.noData')}
          defaultSorted={[
            {
              dataField: StoredValueListColumns.ID,
              order: 'desc'
            }
          ]}
        />
      </div>
    </div>
  );
};
